'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var FILES = exports.FILES = 'FILES';
var EMAIL_METADATA = exports.EMAIL_METADATA = 'EMAIL_METADATA';


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/common-message-format/constants/attachmentTypes.js
// module id = 109
// module chunks = 2 3